import styled, { CSSObject, css, keyframes } from 'styled-components';
import { Variants } from './types';

interface SkeletonStyledProps {
  variant?: keyof typeof Variants;
  width?: number | string;
  height?: number | string;
  size?: string;
  sx?: CSSObject;
}

export const loading = keyframes`
  0% { background-position:0 50%; }
  50% { background-position:100% 50%; }
  100% { background-position:0 50%; }
`;
// TODO: alex refactor animation effect
const animation = () =>
  css`
    ${loading} 1.1s ease infinite
  `;

const AnimatedDiv = styled.div`
  background: linear-gradient(270deg, #f2f2f2, #e5e5e5);
  background-size: 200% 200%;
  transform: rotateZ(360deg);
  animation: ${animation};
`;

const SkeletonStyled = styled(AnimatedDiv)<SkeletonStyledProps>(
  ({ theme, width, height, variant, size, sx }) => {
    let styleSheet: CSSObject = {
      boxSizing: 'border-box',
      display: 'block',
      width,
      height,
    };

    if (variant === Variants.circle) {
      styleSheet.borderRadius = '50%';
    }

    if (variant === Variants.text) {
      styleSheet = {
        ...styleSheet,
        width: 'auto',
        height: 'auto',
        fontSize: theme.font.size[size],
        '&:before': {
          content: "'\\00a0'",
        },
      };
    }

    return {
      ...styleSheet,
      ...sx,
    };
  },
);

export { SkeletonStyled };
